export default "__VITE_ASSET__D9u7OrYt__"